import React from 'react';
import { Typography } from '@mui/material';
import useColor from '../../../hooks/site/useColor';
import useToast from '../../../hooks/useToast';

export default function TypographyText({ children, isCopy, ...props }) {
  const { grey } = useColor();
  const { infoToast } = useToast();

  const onTextCopy = () => {
    navigator.clipboard.writeText(isCopy).then((e) => {
      infoToast('copied to your clipboard');
    });
  };

  const dopSX = isCopy
    ? {
        background: grey[100],
        p: 0.75,
        borderRadius: 1,
        cursor: 'pointer',
        display: 'inline',
        width: 'fit-content'
      }
    : {};

  return (
    <Typography
      component={'span'}
      fontSize={12}
      onClick={isCopy ? onTextCopy : undefined}
      {...props}
      sx={{
        maxWidth: '300px',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        lineHeight: '120%',
        ...dopSX,
        ...props.sx
      }}>
      {children}
    </Typography>
  );
}
